import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "data-table-column-header" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "data-table-column-header__text" }
const _hoisted_4 = {
  key: 0,
  class: "data-table-column-header__sort-icon"
}
const _hoisted_5 = {
  key: 0,
  class: "data-table-column-header__filter-popover"
}
const _hoisted_6 = { class: "data-table-column-header__filter-header" }
const _hoisted_7 = { class: "data-table-column-header__filter-title" }
const _hoisted_8 = { class: "data-table-column-header__filter-options" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "data-table-column-header__filter-option-label" }

import { computed, ref, onMounted, onUnmounted } from "vue";
import { Icon } from "@iconify/vue";
import Checkbox from "@/components/ui/Checkbox.vue";
import type { SortDirection, FilterOption } from "./types";

interface Props {
  label: string;
  sortable?: boolean;
  sortDirection?: SortDirection;
  onSort?: (direction: SortDirection) => void;
  filterable?: boolean;
  filterType?: "multi-select" | "alphabetic";
  filterOptions?: FilterOption[];
  activeFilters?: string[];
  onFilter?: (values: string[]) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnHeader',
  props: {
    label: {},
    sortable: { type: Boolean, default: false },
    sortDirection: {},
    onSort: {},
    filterable: { type: Boolean, default: false },
    filterType: {},
    filterOptions: { default: () => [] },
    activeFilters: { default: () => [] },
    onFilter: {}
  },
  setup(__props: any) {

const props = __props;

const filterOpen = ref(false);
const filterWrapperRef = ref<HTMLElement | null>(null);
const hasActiveFilters = computed(() => props.activeFilters.length > 0);

// Alphabetic filter state
const alphabeticFilterDirection = computed(() => {
  if (props.filterType === "alphabetic" && props.sortable) {
    return props.sortDirection;
  }
  return null;
});

const handleSort = () => {
  if (!props.sortable || !props.onSort) return;

  if (props.sortDirection === null) {
    props.onSort("asc");
  } else if (props.sortDirection === "asc") {
    props.onSort("desc");
  } else {
    props.onSort(null);
  }
};

const toggleFilter = () => {
  filterOpen.value = !filterOpen.value;
};

const handleFilterToggle = (value: string) => {
  if (!props.onFilter) return;

  if (props.activeFilters.includes(value)) {
    props.onFilter(props.activeFilters.filter((f) => f !== value));
  } else {
    props.onFilter([...props.activeFilters, value]);
  }
};

const clearFilters = () => {
  props.onFilter?.([]);
};

const handleAlphabeticFilter = () => {
  if (!props.sortable || !props.onSort) return;

  // Cycle through: null → asc → desc → null
  if (props.sortDirection === null) {
    props.onSort("asc");
  } else if (props.sortDirection === "asc") {
    props.onSort("desc");
  } else {
    props.onSort(null);
  }
};

const handleClickOutside = (event: MouseEvent) => {
  if (filterWrapperRef.value && !filterWrapperRef.value.contains(event.target as Node)) {
    filterOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([
        'data-table-column-header__label',
        {
          'data-table-column-header__label--sortable':
            __props.sortable || (__props.filterable && __props.filterType === 'alphabetic'),
        },
      ]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.filterable && __props.filterType === 'alphabetic' ? handleAlphabeticFilter() : handleSort())),
      disabled: !__props.sortable && !(__props.filterable && __props.filterType === 'alphabetic')
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
      (__props.sortable || (__props.filterable && __props.filterType === 'alphabetic'))
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            (__props.sortDirection === 'asc')
              ? (_openBlock(), _createBlock(_unref(Icon), {
                  key: 0,
                  icon: "mdi:arrow-up",
                  class: "data-table-column-header__icon"
                }))
              : (__props.sortDirection === 'desc')
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: 1,
                    icon: "mdi:arrow-down",
                    class: "data-table-column-header__icon"
                  }))
                : (_openBlock(), _createBlock(_unref(Icon), {
                    key: 2,
                    icon: "mdi:unfold-more-horizontal",
                    class: "data-table-column-header__icon data-table-column-header__icon--default"
                  }))
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2),
    (
        __props.filterable && __props.filterType === 'multi-select' && __props.filterOptions && __props.filterOptions.length > 0
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "data-table-column-header__filter-wrapper",
          ref_key: "filterWrapperRef",
          ref: filterWrapperRef
        }, [
          _createElementVNode("button", {
            class: _normalizeClass([
          'data-table-column-header__filter-button',
          {
            'data-table-column-header__filter-button--active': hasActiveFilters.value,
          },
        ]),
            onClick: toggleFilter
          }, [
            _createVNode(_unref(Icon), { icon: "mdi:filter-outline" })
          ], 2),
          _createVNode(_Transition, { name: "filter-popover" }, {
            default: _withCtx(() => [
              (filterOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, "Filter by " + _toDisplayString(__props.label), 1),
                      (hasActiveFilters.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "data-table-column-header__filter-clear",
                            onClick: clearFilters
                          }, [
                            _createVNode(_unref(Icon), { icon: "mdi:close" }),
                            _cache[2] || (_cache[2] = _createTextVNode(" Clear ", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filterOptions, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: option.value,
                          class: "data-table-column-header__filter-option",
                          onClick: _withModifiers(($event: any) => (handleFilterToggle(option.value)), ["stop"])
                        }, [
                          _createVNode(Checkbox, {
                            "model-value": __props.activeFilters.includes(option.value),
                            "onUpdate:modelValue": () => handleFilterToggle(option.value),
                            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                            size: "sm"
                          }, null, 8, ["model-value", "onUpdate:modelValue"]),
                          (option.icon)
                            ? (_openBlock(), _createBlock(_unref(Icon), {
                                key: 0,
                                icon: option.icon,
                                class: "data-table-column-header__filter-option-icon"
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(option.label), 1)
                        ], 8, _hoisted_9))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})